





import Vue from 'vue'
import { Datetime } from 'vue-datetime'
export default Vue.extend({
    components: { Datetime },
    props: {
        displayColor: {
            type: String,
            default: 'black'
        },
        value: {
            type: String,
            default: null
        }
    },
    data: () => ({
        //  We use the 'mounted' state to ignore the first @input from the Vue datetime component
        mounted: false
    }),
    mounted() {
        //  Set the mounted state to true
        this.mounted = true
    },
    computed: {
        inputStyle() {
            return {
                width: '100%',
                height: '24px',
                cursor: 'pointer',
                color: this.displayColor
            }
        }
    },
    methods: {
        onInput(date: string): void {
            //  If the component is NOT mounted, ignore the input event (this is a known bug with Vue Datetime component)
            if (!this.mounted) return

            //  Else, emit the selected date to the parent
            this.$emit('input', date)
        }
    }
})
